"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPromise = void 0;
function isPromise(subject) {
    // @ts-ignore
    return !!subject && typeof subject['then'] === 'function';
}
exports.isPromise = isPromise;
//# sourceMappingURL=isPromise.js.map